import angular from 'angular';
import {
  userService,
  loaderService,
  reportsSharedModelService,
} from 'app/services';
import { actionIcon } from 'app/components/global';

import reportTypes from './reportTypes';

import directive from './scheduled-reports.directive';
import controller from './scheduled-reports.controller';


export const scheduledReportsRouteConfig = {
  template: require('./scheduled-reports.html'),
  controller: 'ScheduledReportsController',
  controllerAs: 'scheduledReportsVM',
};

export default angular.module('app.components.reports.scheduledReports', [
  userService,
  loaderService,
  reportsSharedModelService,
  actionIcon,
  reportTypes,
])
  .directive('scheduledReports', directive)
  .controller('ScheduledReportsController', controller)
  .name;

console.log('app.components.reports.scheduledReports created');
